module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp3_6000.f270c8f4.png";